import { DefaultFooter } from '@ant-design/pro-components';
import dayjs from 'dayjs';
import React from 'react';

const Footer = () => {
  return <DefaultFooter copyright={`${dayjs().year()} 紫光园`} />;
};
export default Footer;
